import jobuwinLoadingIcon from "../assets/jobuwin-loading-icon.svg";

/**
 * Centered JOBUWIN mark + title (+ optional subtitle). Use for route and data loading states.
 * @param {{ title: string; subtitle?: string; compact?: boolean }} props
 */
export default function JobuwinPageLoading({ title, subtitle, compact = false }) {
  return (
    <div
      className={`job-detail-loading-screen${compact ? " job-detail-loading-screen--compact" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="job-detail-loading-screen-inner">
        <img
          src={jobuwinLoadingIcon}
          alt=""
          className="job-detail-loading-mark"
          width={160}
          height={160}
          decoding="async"
        />
        <h1 className="job-detail-loading-title">{title}</h1>
        {subtitle ? <p className="subtitle job-detail-loading-subtitle">{subtitle}</p> : null}
      </div>
    </div>
  );
}
